<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

    

   document.addEventListener("DOMContentLoaded", function() {
    const prevButton = document.getElementById("customize-action-previous");
    const nextButton = document.getElementById("customize-action-next");
    const reviewButton = document.getElementById("customize-action-review");
    const submitButton = document.getElementById("customize-action-submit");
    const measurementItems = document.querySelectorAll(".item.vmeasurement-owl-item");

    // Get all input elements
const inputs = document.querySelectorAll('.measurment_value');

// Get the progress bar element
const progressBar = document.getElementById('v_progress_bar');


    let currentIndex = 0;
// Calculate the total number of inputs
const totalInputs = inputs.length;

// Initialize the filled inputs counter
let filledInputs = 0;   
                                                                                             

// Update progress function
function updateProgress() {
    // Increment filled inputs counter if the input is filled
    filledInputs = 0;
    inputs.forEach(input => {
        if (input.value !== '') {
            filledInputs++;
        }
    });
                        
    // Calculate progress percentage
    const progressPercentage = Math.floor((filledInputs / totalInputs) * 100);

    // Update progress bar width and content
    progressBar.style.width = `${progressPercentage}%`;
    progressBar.textContent = `${progressPercentage}%`;
}

// Add event listener to all inputs
inputs.forEach(input => {
    input.addEventListener('input', updateProgress);
});
                          
// Initialize progress bar
updateProgress();


    // Function to hide all measurement items except the one at the specified index
    function showItem(index) {
        measurementItems.forEach((item, i) => {
            if (i === index) {
                item.style.display = "block";
            } else {
                item.style.display = "none";       
            }
        });
    }

    // Function to check if the input field of the current item is filled
    function isInputFilled() {
        const inputs = measurementItems[currentIndex].querySelectorAll("input");
        for (let i = 0; i < inputs.length; i++) {
            if (!inputs[i].value) {
                return false;
            }
        }
        return true;
    }

    // Show the first item initially
    showItem(currentIndex);

    nextButton.addEventListener("click", function() {
        // Proceed to the next item only if the input field of the current item is filled
        if (isInputFilled()) {
            currentIndex++;
            if (currentIndex < measurementItems.length) {
                showItem(currentIndex);
                // Display the "Previous" button after the first item
                if (currentIndex === 1) {
                    prevButton.style.display = "block";
                }
            } else {
                // If there are no more items, show the review or submit button
                reviewButton.style.display = "block";
                submitButton.style.display = "block";
                nextButton.style.display = "none";
            }
        } else {
            // Notify the user to fill the input field before proceeding
            alert("Please fill in the input field before proceeding to the next item.");
        }
    });

    prevButton.addEventListener("click", function() {
        currentIndex--;
        showItem(currentIndex);
        // Hide the "Previous" button if the first item is reached
        if (currentIndex === 0) {
            prevButton.style.display = "none";
        }
    });

    // Add event listener for the "Review" button
    reviewButton.addEventListener("click", function() {
        // Display a review of the entered measurements
        // You can implement your logic here
    });

    // Add event listener for the "Submit & Add to Cart" button
    submitButton.addEventListener("click", function() {
        // Submit the form and add the customized item to the cart
        // You can implement your logic here
    });
});






$('.multiple-items').slick({
  infinite: true,
  slidesToShow: 4.3,
  slidesToScroll: 1,
       responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.2,
        slidesToScroll: 1,
        infinite: true, 
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2.2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1
      }
    },
   {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1
      }
    }
         
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// customer review slider

$('.center').slick({
  centerMode: true,
  centerPadding: '40px',
  slidesToShow: 4,
   nextArrow: '<button type="button" class="slick-next border-0" style="background-color: rgb(0 102 255 / 23%);"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
  prevArrow: '<button type="button" class="slick-prev border-0" style="background-color: rgb(0 102 255 / 23%);"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
    
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 580,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    },
     {
      breakpoint: 320,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});
// customer review slider end

// for journey
$('.journey').slick({
  centerMode: true,
  centerPadding: '80px',
  slidesToShow: 3,
   nextArrow: '<button type="button" class="slick-next border-0" style="background-color: #8ae7b4;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
  prevArrow: '<button type="button" class="slick-prev border-0" style="background-color: #8ae7b4;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
    
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '30px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 580,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

//     $(document).ready(function() {
// $('.multiple-items').mousewheel(function(e, delta) {
// this.scrollLeft -= (delta);
// e.preventDefault();
// });
// });
//      const slider = $(".multiple-items");
//   var scrollCount = null;
// var scroll= null;

//   slider.on('wheel', (function(e) {
//     e.preventDefault();
    
//     clearTimeout(scroll);
//     scroll = setTimeout(function(){scrollCount=0;}, 50);
//     if(scrollCount) return 0;
//     scrollCount=1;

//     if (e.originalEvent.delta < 0) {
//       $(this).slick('slickNext');
//     } else {
//       $(this).slick('slickPrev');
//     }
//   }));


    function googleTranslateElementInit() {
      new google.translate.TranslateElement({pageLanguage: 'en', layout: google.translate.TranslateElement.FloatPosition.TOP_LEFT}, 'google_translate_element');
    }

    function triggerHtmlEvent(element, eventName) {
      var event;
      if (document.createEvent) {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, true, true);
        element.dispatchEvent(event);
      } else {
        event = document.createEventObject();
        event.eventType = eventName;
        element.fireEvent('on' + event.eventType, event);
      }
    }

    jQuery('.lang-select').click(function() {
      var theLang = jQuery(this).attr('data-lang');
      jQuery('.goog-te-combo').val(theLang);

      window.location = jQuery(this).attr('href');
      location.reload();
    });





    
function reveal() {
    var reveals = document.querySelectorAll(".tablinks");
  
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
  
      if (elementTop < windowHeight - elementVisible) {~
        reveals[i].classList.add("in-view");
      } else {
        reveals[i].classList.remove("in-view");
      }
    }
  }
  
  window.addEventListener("scroll", reveal);




// certificate

$('.certificate').slick({
  infinite: true,
  slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 9000,
  dots: true,
  nextArrow: '<button type="button" class="slick-next border-0" style="background-color: #fff;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
    prevArrow: '<button type="button" class="slick-prev border-0" style="background-color: #fff;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
                             
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         arrows: true,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false
      }
    }
  ]
});


 $(window).on('scroll', function () {
        var v = $(window).scrollTop();
        if (v > 200) {
            $('.draw-line').animate({"height": "3%","max-height":"100%"},500);
        }
        else {
            $('.draw-line').animate({"height": "1%","max-height":"100%"},500);
        }
    }); 


   
const scriptURL = 'https://script.google.com/macros/s/AKfycbzUJGUwBVi-oOGmQM-8IEyEUUSJnNCU7g_x5k2b44mBmsxQUP1lRI7DtooOf-9yj_ki/exec'
  const form = document.forms['contact-us']
 
  form.addEventListener('submit', e => {
    e.preventDefault()
    fetch(scriptURL, { method: 'POST', body: new FormData(form)})
      .then(response => console.log('Success!', response))
      .catch(error => console.error('Error!', error.message))
  })


 let output = document.getElementById('output');
      const formToReset = document.getElementById('demo_form');
      formToReset.addEventListener('submit', (e) => {
         e.preventDefault();
         formToReset.reset();
         output.innerHTML += "The form is resetted successfully!"
    });



function validateForm() {
  // Get the values of the input fields
  var name = document.getElementById("name1").value;
  var email = document.getElementById("email1").value;

  // Check if the input fields have values
  if (name === "" || email === "") {
    // Display an error message
    alert("Please fill in all fields.");

    // Prevent the form from submitting
    return false;
  }

  // If the input fields have values, redirect to the thank you page
  window.location.href = "https://yogamanlab.com/pages/thank-you";

  // Prevent the form from submitting
  return false;
}

function calculator() {
   var element = document.getElementById("div1");
   element.classList.add("mystyle");
   var element = document.getElementById("div2");
   element.classList.add("mystyli");
}





// sticky buy now button on product page

// $(window).scroll(function() {
// var scroll = $(window).scrollTop();

// if (scroll >= 50) {
// $(".productView-stickyCart").addClass("activebtn");
// } else {
// $(".productView-stickyCart").removeClass("activebtn");
// }
// });


$(function(){
    
    var twoToneButton = document.querySelector('.shopify-payment-button__button--unbranded');
     twoToneButton.innerHTML = "Buy";
    twoToneButton.addEventListener("click", function() {
        twoToneButton.innerHTML = "Buy now";
        twoToneButton.classList.add('spinning');
        
      setTimeout( 
            function  (){  
                twoToneButton.classList.remove('spinning');
                twoToneButton.innerHTML = "Buy now";
                
            }, 6000);
    }, false);
    
});
















// Product data for the different tabs
let currentProductIndex = 0;

const products = [
    {
      title: "Sativa Bud",
      desc: "Nisl vel pretium lectus quam id leo in vitae. Pellentesque adipiscing commodo elit.",
      type: "Sativa-Dominant",
      thc: "THC 120.0-180.0 mg/g",
      cbd: "CBD 0.4-0.9 mg/g",
      img: "https://cdn.shopify.com/s/files/1/0317/4770/2919/files/Diab-99.9-type-1-Set-1.png?v=1693205678" // Change to actual image link
    },
    {
      title: "Indica Bud",
      desc: "Indica vel pretium lectus quam id leo in vitae. Pellentesque adipiscing commodo elit.",
      type: "Indica-Dominant",
      thc: "THC 150.0-200.0 mg/g",
      cbd: "CBD 0.5-1.0 mg/g",
      img: "//rayoflightthemes.com/wordpress-themes/herbalist-wordpress-theme/wp-content/uploads/2022/08/hero-img3-231.png" // Change to actual image link
    },
    {
      title: "Hybrid Bud",
      desc: "Hybrid vel pretium lectus quam id leo in vitae. Pellentesque adipiscing commodo elit.",
      type: "Hybrid",
      thc: "THC 130.0-190.0 mg/g",
      cbd: "CBD 0.3-0.8 mg/g",
      img: "//rayoflightthemes.com/wordpress-themes/herbalist-wordpress-theme/wp-content/uploads/2022/08/cannabis-hero-1.png" // Change to actual image link
    }
  ];
  
  function showProduct(index) {
    const productContent = document.getElementById("productContent");
    const productImage = document.getElementById("productImage");
    const tooltip = document.getElementById("tooltip");
    
    // Fade out effect
    productContent.classList.add("fade-out");
    productImage.classList.add("fade-out");
    
    setTimeout(() => {
      // Update the content and image
      productContent.querySelector("#productTitle").innerText = products[index].title;
      productContent.querySelector("#productDesc").innerText = products[index].desc;
      productContent.querySelector("#productType").innerHTML = `<strong>${products[index].type}</strong>`;
      productContent.querySelector("#thcLevel").innerText = products[index].thc;
      productContent.querySelector("#cbdLevel").innerText = products[index].cbd;
      productImage.src = products[index].img;
  
      // Update tooltip
      tooltip.innerText = `THC: ${products[index].thc}\nCBD: ${products[index].cbd}`;
  
      // Fade in effect
      productContent.classList.remove("fade-out");
      productImage.classList.remove("fade-out");
    }, 300); // Match the duration of the fade-out animation
  }
  
  // Initially display the first product
  showProduct(currentProductIndex);
  
  // Add click events to dots
  const dots = document.querySelectorAll(".dot");
  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      currentProductIndex = index;
      showProduct(currentProductIndex);
      dots.forEach(d => d.classList.remove("active"));
      dot.classList.add("active");
    });
  });
  
  // Add click events for next and previous buttons
  document.getElementById("prevBtn").addEventListener("click", () => {
    currentProductIndex = (currentProductIndex - 1 + products.length) % products.length; // Loop back to last product
    showProduct(currentProductIndex);
    updateActiveDot();
  });
  
  document.getElementById("nextBtn").addEventListener("click", () => {
    currentProductIndex = (currentProductIndex + 1) % products.length; // Loop back to first product
    showProduct(currentProductIndex);
    updateActiveDot();
  });
  
  // Function to update the active dot
  function updateActiveDot() {
    dots.forEach(d => d.classList.remove("active"));
    dots[currentProductIndex].classList.add("active");
  }
  
  // Tooltip functionality
  const imageContainer = document.querySelector('.image-container');
  imageContainer.addEventListener('mouseenter', () => {
    tooltip.style.display = 'block';
  });
  imageContainer.addEventListener('mouseleave', () => {
    tooltip.style.display = 'none';
  });
  
  // Show the first product tooltip initially
  tooltip.innerText = `THC: ${products[0].thc}\nCBD: ${products[0].cbd}`;



         
// This script is an example for adding hover effects or tooltips if you want to expand later.

document.querySelectorAll('.test-item').forEach(item => {
    item.addEventListener('mouseover', function() {
        this.style.backgroundColor = '#e0f7fa';
    });
    
    item.addEventListener('mouseout', function() {
        this.style.backgroundColor = '#fff';
    });
});
         







